import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { Promise } from 'bluebird';
import usePermissions from 'hooks/permissions-hooks';
import actions from 'roles-actions-permissions/actions';
import ForgotPasswordForm from 'pages/ForgotPasswordForm';
import ChangePermissions from 'pages/ChangePermissions';
import AppLoader from './components/basic/AppLoader';
import PrivateRoute from './components/Wrappers/PrivateRoute';
import CenterLayout from './theme/layouts/CenterLayout';
import Login from './components/Login';
import Register from './components/Register';
import Logout from './components/Logout';
import BasicLayout from './theme/layouts/BasicLayout';
import AccountPage from './pages/AccountPage';
import Playground from './playground/Playground';
import HomePage from './pages/HomePage';
import EshopPage from './pages/EshopPage';
import RolesActionsPermissions from './roles-actions-permissions/RolesActionsPermissions';
import DebugPage from './pages/DebugPage';
import { useAuth } from './AuthCtx';
import pages from './components/layout/left-panel/pages';
import SubMenuPage from './pages/SubMenuPage';

const EmptyLayout = ({ children }) => {
  return (
    <div style={ { marginTop: '100px', display: 'flex', justifyContent: 'center' } }>
      <div style={ { maxWidth: '800px', width: '100%' } }>
        {children}
      </div>
    </div>
  );
};

function App() {
  const { userIsLoggedIn, userIsAuthenticating, getMe } = useAuth();

  const [ loading, setLoading ] = useState(true);
  const { hasPermissions } = usePermissions();

  useEffect(() => {
    Promise.try(() => {
      return getMe();
    }).finally(() => {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    });
  }, []);

  if (userIsAuthenticating || loading) {
    return <AppLoader style={ { height: '100vh' } } />;
  }

  return (
    <>
      <Router>
        <Switch>
          <PrivateRoute
            authed={ userIsLoggedIn }
            path='/'
            exact
            layout={ BasicLayout }
            component={ HomePage }
            redirectPath='/login'
          />
          <PrivateRoute
            authed={ userIsLoggedIn }
            path='/submenu/:key'
            exact
            layout={ BasicLayout }
            component={ SubMenuPage }
          />
          <PrivateRoute
            authed={ userIsLoggedIn && hasPermissions(actions.VIEW_HOME_PAGE) }
            path='/home'
            exact
            layout={ BasicLayout }
            component={ HomePage }
            redirectPath='/login'
          />
          <PrivateRoute
            authed={ !userIsLoggedIn }
            path='/login'
            exact
            layout={ CenterLayout }
            component={ Login }
            redirectPath='/'
          />
          <PrivateRoute
            authed={ !userIsLoggedIn }
            path='/forgot-password'
            exact
            layout={ EmptyLayout }
            component={ ForgotPasswordForm }
            redirectPath='/'
          />
          <PrivateRoute
            authed={ !userIsLoggedIn }
            path='/register'
            exact
            layout={ CenterLayout }
            component={ Register }
            redirectPath='/'
          />
          <PrivateRoute
            authed={ userIsLoggedIn }
            path='/logout'
            exact
            layout={ CenterLayout }
            component={ Logout }
            redirectPath='/'
          />
          <PrivateRoute
            authed={ userIsLoggedIn }
            path='/my-account'
            layout={ BasicLayout }
            component={ AccountPage }
          />
          <PrivateRoute
            authed
            path='/playground'
            layout={ BasicLayout }
            component={ Playground }
          />

          <PrivateRoute
            authed={ userIsLoggedIn && hasPermissions(actions.VIEW_B2B_PAGE) }
            path='/eshop'
            layout={ BasicLayout }
            component={ EshopPage }
          />

          <PrivateRoute
            authed
            path='/roles-actions'
            layout={ CenterLayout }
            component={ RolesActionsPermissions }
          />
          <PrivateRoute
            authed
            path='/debug-token-manager'
            layout={ BasicLayout }
            component={ DebugPage }
          />

          <PrivateRoute
            authed
            path='/change-permissions'
            layout={ BasicLayout }
            component={ ChangePermissions }
          />

          {
            pages
              .filter((p) => { return '/' !== p.path; })
              .map((p) => {
                const { path, permissions, component } = p;
                return (
                  <PrivateRoute
                    key={ path }
                    authed={ userIsLoggedIn && hasPermissions(permissions) }
                    path={ `${ path }` }
                    layout={ BasicLayout }
                    component={ component }
                  />
                );
              })
          }
          <PrivateRoute
            authed
            path='/*'
            layout={ BasicLayout }
            component={ () => {
              return <div>Not found</div>;
            } }
          />
        </Switch>
      </Router>
    </>

  );
}

export default App;
